import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  GetInvoiceDetailsRequest,
  GetInvoiceDetailsResult,
} from './getInvoiceDetails.types';

export async function getInvoiceDetails({
  accountReceivableId,
  organizationId,
}: GetInvoiceDetailsRequest): Promise<GetInvoiceDetailsResult> {
  const response = await axiosInstance.get<GetInvoiceDetailsResult>(
    `/invoices/${accountReceivableId}`,
    {
      headers: {
        'X-Organization-Id': organizationId,
      },
    }
  );
  return response.data;
}
